let base_url;

if (process.env.NODE_ENV === "development") {
  base_url = {
    protocol: "http",
    hostname: "localhost",
    port: "8000",
    api_base_path: "/",
  };
} else {
  base_url = {
    protocol: "https",
    hostname: "portal.floorwalk.in",
    port: "",
    api_base_path: "/",
  };
}
export { base_url };


// "audit_cycle" ---> "/audit_cycle"
export const joinApiPath = (base, endpoint = "") =>
  `${base.replace(/\/+$/, "")}/${String(endpoint).replace(/^\/+/, "")}`;